import { useEffect, useRef, useState } from 'react';

import { performanceApi, type PrescriptionImage } from '../api/performance.api';

/**
 * 처방 이미지 presigned URL — 만료(로드 실패)되면 download-url로 한 번 다시 받는다 (M-16 · M-18).
 * 원본이 없으면(imageUrl null) src도 null이다.
 *
 * 사용: const { src, onError } = useRefreshableImageUrl(ym, clinicId, image);
 *       {src && <img src={src} onError={onError} />}
 */
export const useRefreshableImageUrl = (
  month: string,
  clinicId: number,
  image: PrescriptionImage | undefined,
) => {
  const [src, setSrc] = useState(image?.imageUrl ?? null);
  const retried = useRef(false);

  // 다른 이미지로 넘기거나 목록을 다시 받으면 새 URL로 시작한다
  useEffect(() => {
    setSrc(image?.imageUrl ?? null);
    retried.current = false;
  }, [image?.imageCode, image?.imageUrl]);

  const onError = () => {
    if (!image || !src || retried.current) return;
    retried.current = true;
    performanceApi
      .imageDownloadUrl(month, clinicId, image.imageCode)
      .then((r) => setSrc(r.imageUrl))
      .catch(() => setSrc(null));
  };

  return { src, onError };
};
